import { Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import type { ExclusionAreaObservationComment } from '../../../../types/apiModels'

interface ExclusionAreaObservationCommentCardProps {
  comment: ExclusionAreaObservationComment
}

export const ExclusionAreaObservationCommentCard: React.FC<
  ExclusionAreaObservationCommentCardProps
> = ({ comment }) => {
  return (
    <Grid container mb={0.5}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          inputProps={{ readOnly: true }}
          rows={2}
          value={comment.message}
        />
      </Grid>
      <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }} xs={12}>
        <Typography mr={1} variant="caption">
          {comment.createdBy}
        </Typography>
        <Typography variant="caption">
          {new Date(comment.createdAt).toLocaleDateString()}
        </Typography>
      </Grid>
    </Grid>
  )
}
